import type { MenuItem } from 'primevue/menuitem';

export default [
    {
        label: 'Database inkopen',
        icon: 'pi pi-database',
        items: [
            {
                label: 'Inkoopproducten',
                icon: 'pi pi-shopping-cart',
                to: '/products',
            },
            {
                label: 'Leveranciers',
                icon: 'pi pi-truck',
                to: '/suppliers',
            },
            {
                label: 'Leveranciersvestigingen',
                icon: 'pi pi-map-marker',
                to: '/supplierbranches',
            },
        ],
    },
    {
        label: 'Database gevaren',
        icon: 'pi pi-database',
        items: [
            {
                label: 'Gevaren',
                icon: 'pi pi-exclamation-triangle',
                to: '/risks',
            },
            {
                label: 'Gevaarcategorieën',
                icon: 'pi pi-sitemap',
                to: '/risks/threat-category',
            },
            {
                label: 'Productcategorieën',
                icon: 'pi pi-list',
                to: '/risks/product-category',
            },
            {
                label: 'Product predicaten',
                icon: 'pi pi-question',
                to: '/question-predicates',
            },
        ],
    },
    {
        label: 'Beslismodellen',
        icon: 'pi pi-sliders-v',
        items: [
            {
                label: 'Risicomatrix',
                icon: 'pi pi-table',
                to: '/risk-configurations',
            },
            {
                label: 'Beslismatrix',
                icon: 'pi pi-table',
                to: '/verification-configurations',
            },
        ],
    },
    {
        label: 'Rapportages',
        icon: 'pi pi-file',
        items: [
            {
                label: 'Rapporten',
                icon: 'pi pi-file',
                to: '/reports',
            },
        ],
    },
] satisfies MenuItem[];
